import { axiosSwagger } from "@/axios";

export const state = {
  currentFile: {
    loading: false,
    data: [],

    selectedID: null,
  },
}


export const getters = {
}


export const mutations = {
  // CURRENT LOCATION FILE DATA
  currentDataLoading: (state, loading) => {
    state.currentFile.loading = loading;
  },
  setCurrentData: (state, data) => {
    state.currentFile.data = modifyData( data );
  },
  removeData: (state, id) => {
    state.currentFile.data = state.currentFile.data.filter(
      (el) => el.id !== id
    );
  },
  // remove multiple file location
  removeMultipleFileLocation: (state, dataArr) => {
    state.currentFile.data = state.currentFile.data.filter(
      (el) => !dataArr?.includes(el.id)
    );
  },
}


export const actions = {
  // GET FILE BY LOCATION ID
  async readFileByLocationId({ commit }, obj) {
    obj.isLoad ? commit("currentDataLoading", true) : "";

    return await axiosSwagger
    .get(`/api/FileManager/FileLocation/${obj.id}`)
    .then((response) => {
      commit("setCurrentData", response.data);
      obj.isLoad ? commit("currentDataLoading", false) : "";

      return response;
    })
    .catch(() => {
      obj.isLoad ? commit("currentDataLoading", false) : "";
    });
  },
  // DELETE MULTIPLE FILE LOCATION
  async multipleDeleteFileLocation({ commit }, data) {
    return await axiosSwagger
    .deleteWithBody(`/api/FileLocation/Remove/Multiple`, data)
    .then((response) => {
      commit("removeMultipleFileLocation", data.map(e => e.id));

      return response;
    });
  },
}


// modify data for file posting status
const modifyData = (arrayData) => {
  if(arrayData?.length ?? false){
    arrayData.forEach(e => {
      e.status = (e.filePostings?.length ?? false) ? e.filePostings.find(x => x.fileManagerId === e.id).status.toLowerCase() : '';
    });

    return arrayData;
  }

  return [];
};